import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import elementStyles from './elements.module.scss'

const TypeProps = {
  color: PropTypes.oneOf([
    'solar',
    'solarOutline',
    'evantaBlue',
    'gartnerBlue',
    'evantaBlueOutline',
    'inactiveGray',
    'greyOutline',
    'noBtnContainer',
    'lightBase',
    'lightBaseOutline',
    'lightActive',
    'errorGraphic',
    'inactive',
    'darkBase',
    'whiteOutline'
  ]).isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.elementType
  ]).isRequired,
  size: PropTypes.oneOf(['large', 'med', 'small']),
  disabled: PropTypes.bool,
  textOnly: PropTypes.bool
}

const Button = ({
  color,
  onClick,
  label,
  size,
  disabled,
  textOnly,
  style,
  id,
  iconLeft = null,
  iconRight = null
}) => (
  <button
    name={label}
    className={classNames(
      elementStyles.button,
      elementStyles[`${size}CTA`],
      elementStyles[color],
      { [elementStyles.noPadding]: textOnly }
    )}
    onClick={onClick}
    disabled={disabled}
    id={id}
    style={{ ...style }}
  >
    {iconLeft && <span style={{ marginRight: 10, alignItems: 'center' }}>{iconLeft}</span>}
    {label}
    {iconRight && <span style={{ marginLeft: 10, alignItems: 'center' }}>{iconRight}</span>}
  </button>
)

Button.propTypes = {
  ...TypeProps
}

export default Button
